import { useUpdateAtom } from 'jotai/utils';
import { Router } from 'next/router';
import { useEffect } from 'react';
import { resetVirtualProductListScrollIndexAtom } from 'components/common/store/product';

/**
 * 검색에서 사용하는 product_virtual_list 의 스크롤 초기화 시점을 컨트롤 하기 위함
 * 검색, 카테고리 페이지에서 검색변경은 replace 의 query-string 으로 제어되고 있어 이를 초기화 포인트로 잡는다.
 * @hook
 */
const useResetSearchProductVirtualScroll = (virtual_key: string, replace_path: string) => {
  const resetVirtualProductListScrollIndex = useUpdateAtom(resetVirtualProductListScrollIndexAtom);

  useEffect(() => {
    const resetProductScroll = (url: string) => {
      const is_replace_page = url.startsWith(replace_path);
      if (is_replace_page) {
        resetVirtualProductListScrollIndex(virtual_key);
        window.scrollTo({ top: 0 });
      }
    };
    Router.events.on('routeChangeStart', resetProductScroll);
    return () => {
      Router.events.off('routeChangeStart', resetProductScroll);
    };
  }, [resetVirtualProductListScrollIndex, replace_path, virtual_key]);
};

export default useResetSearchProductVirtualScroll;
